import { useLazyGetDataMonitoringDataQuery, useUpdateDataMonitoringDataMutation } from 'src/services/dataMonitoring';

export const UseDataMonitoringPage = () => {
  const [
    getDataMonitoringData,
    {
      data: monitoringData,
      error: monitoringDataError,
      isError: monitoringDataIsError,
      isLoading: monitoringDataLoading
    }
  ] = useLazyGetDataMonitoringDataQuery();

  const [
    updateDataMonitoring,
    {
      isLoading: updateMonitoringData,
      isSuccess: updateMonitoringDataSuccess,
      isError: updateMonitoringDataIsError,
      error: updateMonitoringDataError
    }
  ] = useUpdateDataMonitoringDataMutation();

  return {
    getDataMonitoringData,
    updateDataMonitoring,
    monitoringData,
    monitoringDataError,
    monitoringDataIsError,
    monitoringDataLoading,
    updateMonitoringData,
    updateMonitoringDataError,
    updateMonitoringDataIsError,
    updateMonitoringDataSuccess
  };
};
